var _path, _path2, _path3, _circle, _circle2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLy = function SvgLy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#239e46",
    d: "M0 0h960v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h960v360H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e70013",
    d: "M0 0h960v120H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 240,
    r: 60,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 492.132,
    cy: 240,
    r: 52.132
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m509.175 240 80.7-26.221L540 282.426v-84.852l49.875 68.647z"
  })));
};
export default SvgLy;